import { PROJECT_CODE } from '../../constants/project';


/**
 * The class name for the gutter.
 *
 * @since 0.1.0
 */
export const CLASS_GUTTER = `${ PROJECT_CODE }__gutter`;

/**
 * The class name for the inner element.
 *
 * @since 0.1.0
 */
export const CLASS_GUTTER_FLOAT = `${ CLASS_GUTTER }__float`;

/**
 * The class name for each row element.
 *
 * @since 0.1.0
 */
export const CLASS_GUTTER_ROW = `${ CLASS_GUTTER }__row`;

/**
 * The class name for each line number element.
 *
 * @since 0.1.0
 */
export const CLASS_LINE_NUMBER = `${ CLASS_GUTTER }__number`;

/**
 * The modifier class to apply `sticky`.
 *
 * @since 0.1.0
 */
export const CLASS_STICKY = `${ CLASS_GUTTER }--sticky`;

/**
 * The status class for the root element.
 *
 * @since 0.1.0
 */
export const CLASS_HAS_GUTTER = 'has-gutter';

